(function () {

    'use strict';

    angular.module('Filters')

        .filter('isInvalid', function () {
            return function (form, name) {
                if (form && form[name]) {
                    if (angular.isArray(name)) return !!name.find(n => {
                        return (form[n].$invalid && form.$submitted) || (form[n].$invalid && form[n].$touched)
                    });
                    return (form[name].$invalid && form.$submitted) || (form[name].$invalid && form[name].$touched);
                }
                return false;
            };
        });
})();


// WEBPACK FOOTER //
// ./js/filters/isInvalid.js